export default {
  0xE07001002: '预约参数有误',
  0xE07001003: '预约时间超出营业时间',
  0xE07001004: '日期间隔超出31天',
  0xE07001006: '预约时间已过',
  0xE03001003: '搜索字段过短',
  0xE08001001: '用户验证码错误',
  0xE03001013: '该订单没有参与调研',
  0xE03001014: '该订单已经提交了',
  0xE03001015: '提交评价数据出错了',
  0xE04001001: '验证码错误',
  0xE08101001: '发送过于频繁，请稍后再试',
  0xE04001002: '该手机已经注册过了',
  0xC98001009: '该手机号尚未注册',
  0xC98001002: '手机号或者密码错误',
  0xC99001006: '订单支付code已清除',
  0xC98001004: '请手动登录',
  0xE03001001: '您预约的时间已被其他用户预约，请重新选择拍摄时间',
  0xA01101009: '您已无法再修改生日',
  // 中间件
  0xE03001021: '该时间已经被预约，请重新选择时间',
  0xE03001330: '验证码不正确',
  0xE03001009: '该订单未找到',
  0xE03001222: '订单已经被绑定了',
  0xA01107001: '验证码不正确',
  0xA011f1001: '验证码不正确',
  // 礼品卡
  0xA01207001: '该节点状态无法关闭/开启',
  0xA01207002: '修改的时间点未在门店预约范围',
  0xE09002110: '充值码错误',
  0xA0110B003: '礼品卡不存在',
  60280545555: '礼品卡不存在',
  60280546307: '礼品卡已经在赠送中',
  // nps
  0xA01109001: 'SN调查问卷未发布,请稍后再试',
  0xA01109002: '订单信息不存在,请稍后再试',
  0xA01109003: '非当前用户的订单,不可查询',
  0xA01109005: 'SN订单已填写',
  // 订单
  0xA01106001: '过多的未支付订单,请先支付或取消订单',
  0xA01106002: '异常的预约拍摄时间',
  0xA01106003: '订单写入失败,请稍后再试',
  0xA01106004: '订单信息不存在,请稍后再试',
  0xA01106005: '非当前用户的订单,不可查询',
  0xA01106006: '异常的订单状态',
  0xA01106007: '预约拍摄时间修改不可超过2次',
  0xA01106008: '订单已被绑定,不可重复绑定',
  0xA01106009: '云端请求数据失败,请稍后再试',
  0xA0110600A: '无效的优惠券',
  0xA0110600B: '礼品卡余额不足',
  0xA0110600C: '无效的内部折扣码',
  0xA0110600D: '订单金额异常,请稍后再试',
  0xA0110600E: '用户信息不存在',
  0xA01107002: '发票金额异常',
  0xA01107003: '该发票已存在，请稍后再试',
  0xA0110600F: '功能升级维护中,如需退款请联系小海马客服哦',
  0xA0123A007: '订单不存在',
  0xA01107004: '不同主体门店不能开票',
  0xA19002008: '订单状态异常',
  0xA19007005: '该门店不支持售卖订单中的零售产品',
  // 支付
  0xA01108001: '订单信息不存在,请稍后再试',
  0xA01108002: '订单支付状态异常,请稍后再试',
  0xA01108003: '非当前用户的订单,不可查询',
  0xA01108004: '支付金额异常,请稍后再试',
  0xA01108005: '非零元订单,不可支付',
  0xA01108006: '异常的支付方式',
  0xA01108007: '支付回调前面验证错误',
  0xA01108008: '支付失败',
  0xA01108009: '回调数据异常',
  0xA0110800A: '订单状态异常,请稍后再试',
  // user
  0xe04001005: '旧密码错误',
  0xC98001003: '请重新登录或者退出重试', // token过期
  0xC98001007: '获取微信授权失败，请退出重新登录',
  43369177099: '您已经设置了密码哦～',
  // 0xC98001003
  // 核心微服务
  // 礼品卡
  0xE09001001: '缺少必填参数',
  0xE09001002: '系列不存在',
  0xE09001003: '主题不存在',
  0xE09001004: '卡面不存在',
  0xE09002105: '礼品卡已激活',
  0xE09001006: '礼品卡余额不足',
  0xE09001007: '退款超过可退金额',
  0xE09001008: '礼品卡订单金额有误',
  0xE09001009: '卡面不是在售',
  0xE09001010: '礼品卡状态无效',
  0xE09001011: '优惠码并没有在微信卡包中, 可能是已经被领取',
  0xE09001012: '部分卡缺失',
  0xE09001013: '礼品卡不存在',
  0xE09001014: '礼品卡已使用',
  0xE09001015: '封面标题已存在',
  0xE09001016: '用户不存在',
  0xE09001017: '部分卡不存在卡面',
  0xE09001018: '可退款金额超过礼品卡真实面值',
  0xE09001019: '退出全部款依旧没有达成要求退款金额',
  0xE09002001: '订单异常',
  0xE09002002: '礼品卡订单支付类型无效',
  0xE09002003: '礼品卡订单状态有误',
  // 优惠券
  0xE09004001: '用户不正确, 通常是该用户没有这张优惠券',
  0xE09004002: '优惠状态不正确, 通常是已使用',
  0xE09004003: '优惠码未到使用时间',
  0xE09004004: '优惠码已过期',
  0xE09001005: '优惠码已使用',
  0xE09004006: '优惠码未激活',
  0xE09004007: '优惠金额不正确',
  0xE09004008: '优惠码不存在或者已过期',
  0xE09004009: '优惠卷不存在',
  0xE09004010: '门店不支持',
  0xE09004011: '参数缺失',
  0xA0110A001: '优惠码不存在,请核实',
  0xA0110A002: '优惠码已使用,请核实',
  0xA0110A003: '优惠码已过期,请核实',
  0xA0110A004: '优惠码已作废,请核实',
  0xA0110A005: '优惠码尚未激活,请核实',
  0xA0110A006: '优惠码尚未开始使用,请核实',
  0xA0110A007: '优惠码已被兑换,请核实',
  0xA0110A008: '操作过于频繁，请稍后重试！',
  0xA0110B002: '操作过于频繁，请稍后重试！',
  0xA0112A001: '产品体验券不存在,请核实',
  0xA01101008: '该优惠券已发放完',
  // 产品
  0xE02201001: '不允许的子项类型',
  0xE02201002: '不允许的节点类型',
  0xE02201003: '当前门店没有这个价格',
  0xE02201004: '当前门店没有这个产品售卖',
  0xE02201005: '计算价格的节点种类不正确',
  0xE02201006: '当前门店购买这个产品时, 人数选择不在限制内',
  0xE02201007: '没有这个优惠规则',
  0xE02201008: '计算价格内部错误',
  // 支付网关
  0xC99002000: '意外错误',
  0xC99002001: '当前开票状态是无效的,通常见于其他状态的发票调用了发货',
  0xC99002002: '发票网关返回了开票成功, 但是并没有给流水号',
  0xC99002003: '发票网关调用失败',
  0xC99002004: '只能删除为手动开具状态的订单',
  // 阿里、新东方活动
  0xA01101001: '用户信息不存在,请重新登录',
  0xA01101002: '邮件验证码错误',
  0xA01101003: '该邮箱地址已被绑定',
  0xA01101004: '该用户已绑定邮箱,不可重复绑定',
  0xA01101005: '操作频繁',
  0xA01101006: '十分抱歉验证失败，您未在此批拍摄名单内。后续名单将持续更新，请耐心等待通知',
  0xA01101007: '校验企业身份失败，无法绑定',
  0xC96003003: '系统错误，请重试',
  0xC96003002: '慢了一步，券已被领完了',
  // 401
  401: '身份过期，请重新登录',
  // 排单表
  0xE07001001: '该时间预约人数已满',
  0xA16011001: '优惠券已领完',
  0xA16011002: '您已经领取过企业福利了哦～',
  0xA16003002: '验证码错误',
  0xA16011003: '该账号不可领取',
  0xA01106016: '该订单已选衣',
  0xA01106017: '订单无需选衣',
  43000008713: '领取优惠券失败',
  43369111561: '预约时间点已过期',
  // 退款确认页
  0xA01213009: '订单与用户不匹配',
  0xE03002303: '退款记录已存在',
  0xA19005005: '兑换太频繁，请稍后再试',
  0xA19006005: '兑换太频繁，请稍后再试',
  0xA01222009: '暂不支持团购订单的退款申请，如需退款请联系客服',
  43369111553: '过多未支付订单，请先支付或取消',
  0xA19006007: '券码状态有误或已被兑换哦～',
  0xA19005007: '券码状态有误或已被兑换哦～',
  0xA19027002: '券码输入有误哦～',
  // 东方美人投票活动
  0xE06005001: '活动尚未开始',
  0xE06005002: '活动已结束',
  0xE06005003: '图像识别失败',
  0xE06005004: '已达到投票上限，明天可再投哦',
  0xE06005005: '必须有参数传递',
  0xA03004001: '该照片已经报名，请更换图片哦～',
  0xA03004002: '已达到投票上限，明天可再投哦',
  0xA03004003: '不能给自己投票',
  0xE06005006: '尚未对照片授权',
  0xE06005007: '不可重复领取',
  0xE06005008: '每个用户活动期间只能抢到一张券',
  0xE06005009: '已抢完',
  0xE06005010: '该IP今日投票次数已达上限，请更换网络',
  0xE06005011: '请先在客户端登录系统',
  0xE06005012: '当前用户信息与订单不匹配',
  0xE06005013: '非法操作，请确认订单信息',
  0xE06005014: '未找到活动记录',
  0xE06005015: '活动记录不合法',
  0xF0106801: '活动过于火爆，请稍后再试',
  // 幸福照相馆
  0xA19028002: '您今日许愿已达上限，请明日再来哦～',
  // 零售订单退款
  0xA19025001: '当前订单状态异常，请检查后重试',
  0xA1900200A: '修改预约次数已达上限',
  0xA19029001: '该门店暂时无法提供服务，可以切换门店哦～'
}
